// extracted by mini-css-extract-plugin
export default {"ratingDialog":"VLoz8DX---styles_ratingDialog__lTHW7","requiredCaption":"VLoz8DX---styles_requiredCaption__o-xNo","closeReviewModal":"VLoz8DX---styles_closeReviewModal__0I-+W"};